import { Button, Container, Grid, Icon, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import logoImage from '../assets/gg-black.svg';
import pageImage from '../assets/gg__illustration--page-not-found-3.svg';

function PageNotFound() {
  return (
    <main id="main-content" className="flex-grow-1 d-flex" role="main">
      <Container>
        <Grid container>
          <Grid size={12}>
            <div className="d-flex flex-column align-items-center align-content-center mt-5 mb-5">
              <Typography
                className="mb-5"
                variant="h6"
                noWrap
                component={Link}
                to="/"
              >
                <Icon
                  sx={{
                    display: 'flex',
                    mr: 1,
                    height: '40px',
                    width: '160px',
                  }}
                >
                  <img src={logoImage} alt="Grant Guardian logo" />
                </Icon>
              </Typography>
            </div>
          </Grid>
        </Grid>
        <Grid container>
          <Grid size={4} sx={{ ml: '16.666667%' }}>
            <div className="d-flex flex-column mb-5 gap-1">
              <Typography variant="display1">404</Typography>
              <Typography variant="h4">Our apologies!</Typography>
              <Typography variant="h6">
                The page you are looking for cannot be found
              </Typography>
            </div>
            <div className="d-flex flex-column">
              <Typography variant="body1">
                <strong>Possible reasons</strong>
              </Typography>
              <ul className="mt-2 mb-5">
                <li className="mt-2">
                  The address may have been typed incorrectly;
                </li>
                <li className="mt-2">It may be a broken or outdated link.</li>
              </ul>
            </div>
            <div className="d-flex gap-3">
              <Button
                component={Link}
                variant="contained"
                color="secondary"
                to="/"
              >
                Grant Guardian Home
              </Button>
              <Button
                component={Link}
                variant="outlined"
                color="secondary"
                to="/help"
              >
                Help center
              </Button>
            </div>
          </Grid>
          <Grid size={5}>
            <figure className="d-flex flex-column justify-content-center align-items-center">
              <img src={pageImage} alt="404 page illustration" />
            </figure>
          </Grid>
        </Grid>
      </Container>
    </main>
  );
}

export default PageNotFound;
